import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { VehicleEquipment as VehicleEquipment } from 'src/app/models/vehicle-equipment';
import { BadaService } from 'src/app/services/bada.service';
import { VehicleVersion } from 'src/app/models/vehicle-version';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { VehicleIdentityComponent } from '../vehicle-identity/vehicle-identity.component';
import { Router } from '@angular/router';
import { RoutesPathEnum } from 'src/app/app-routing.module';


@Component({
  selector: 'app-table-wizard',
  templateUrl: './table-wizard.component.html',
  styleUrls: ['./table-wizard.component.css']
})
export class TableWizardComponent implements OnInit {
  vehicleVersionsToShow: VehicleVersion[] = [];
  vehicleEquipments: VehicleEquipment[] = [];
  vehicleEquipmentsChecked: VehicleEquipment[] = [];

  @ViewChildren("checkboxes") checkboxes: QueryList<MatCheckbox>;

  constructor(private badaService: BadaService, private router: Router) { }

  ngOnInit(): void {
    /**
     * Sottoscrizione alle vehicle info nel bada service
     */
    this.badaService.vehicleInfo.subscribe(vehicleInfo => {
      if (vehicleInfo) {
        this.vehicleVersionsToShow = vehicleInfo.versions;
        this.vehicleEquipments = vehicleInfo.allEquipments;
      }
    });
  }

  /**
   * Funzione scatenata sul cambio delle checkbox degli equipaggiamenti
   */
  onEquipmentChange(equip: VehicleEquipment, evt: MatCheckboxChange): void {
    if (evt && evt.checked) {
      this.vehicleEquipmentsChecked.push(equip);
    }
    else {
      const i = this.vehicleEquipmentsChecked.findIndex(opt => opt.code == equip.code);
      this.vehicleEquipmentsChecked.splice(i, 1)
    }

    this.vehicleVersionsToShow = [];

    for (let index = 0; index < this.badaService.vehicleInfo.getValue().versions.length; index++) {
      const version = this.badaService.vehicleInfo.getValue().versions[index];
      const result = this.vehicleEquipmentsChecked.every(equip => {
        if (version.equipments && version.equipments.length) {
          return version.equipments.find(vEquip => vEquip.code == equip.code)
        }
        else {
          return false;
        }

      });
      if (result) {
        this.vehicleVersionsToShow.push(version);
      }
    }
  }

  /**
   * Svuota tutte le checkbox di selezione optionals e refresha la lista
   */
  clearCheckboxes() {
    this.vehicleEquipmentsChecked = [];
    this.checkboxes.forEach(checkbox => checkbox.checked = false);
    this.onEquipmentChange(null, null);
  }

  /**
   * Click sulla versione (selezione)
   */
  onVehicleVersionClick(vehicleVersion: VehicleVersion) {
    this.badaService.vehicleVersionSelected = vehicleVersion;
    this.router.navigate([RoutesPathEnum.VehicileIdentity]);
  }

}

